export const CHAT_STAT_COLUMNS = [
  { headerLabel: "Contacts", rowLabel: "Total Contacts", getValue: (p) => p.totalContacts },
  {
    headerLabel: "Responded",
    rowLabel: "Responded Users",
    getValue: (p) => p.chatCampaignDetails?.usersResponded,
  },
  {
    headerLabel: "Attempted",
    rowLabel: "Messages Attempted",
    getValue: (p) => p.chatCampaignDetails?.messagesAttempted,
  },
  {
    headerLabel: "Sent",
    rowLabel: "Messages Sent",
    getValue: (p) => p.chatCampaignDetails?.messagesSent,
  },
  {
    headerLabel: "Failed",
    rowLabel: "Messages Failed",
    getValue: (p) => p.chatCampaignDetails?.messagesFailed,
  },
  {
    headerLabel: "Blocked",
    rowLabel: "Messages Blocked",
    getValue: (p) => p.chatCampaignDetails?.messagesBlocked,
  },
];

// name column | 6 stat columns | actions
export const CHAT_ROW_GRID_COLS =
  "grid-cols-[minmax(220px,2fr)_repeat(6,minmax(70px,1fr))_minmax(170px,auto)]";

// campaign(220) + 6 stats(70 each) + actions(170) + 7 gaps(16 each) + row padding(32)
export const CHAT_ROW_MIN_WIDTH = 220 + 6 * 70 + 170 + 7 * 16 + 32;
